import React from 'react';

function PlanList({
  plan,
  setSelectedPlan,
  isSelected,
  userSubscription,
  userPlan,
  // isWarfarePlan = false,
  bestValue = false,
}) {
  const itemClassName = isSelected ? 'plan-item plan-selected' : 'plan-item';
  return (
    <div key={plan.id} className="list-item">
      <i
        onClick={() => setSelectedPlan(plan.id)}
        data-test={`${plan.product.name
          .replaceAll(' ', '-')
          .toLowerCase()}-radio-input`}
        className="plan-radio-icon material-icons radio-icon"
      >
        {isSelected ? 'radio_button_checked' : 'radio_button_unchecked'}
      </i>
      <div onClick={() => setSelectedPlan(plan.id)} className={itemClassName}>
        <div className="plan-item-contents">
          <div className="plan-item-header">
            <div className="title">
              <div>
                {/* {plan.interval === 'year' && !isWarfarePlan
                  ? 'Annual'
                  : plan.interval_count === 1 && !isWarfarePlan
                    ? 'Monthly'
                    : plan.interval_count === 6 && !isWarfarePlan
                      ? 'Semi-Annual'
                      : 'Warfare Only'} */}
                {`${plan.interval === 'year' ? 'Annual' : 'Semi-Annual'} ${plan?.isOccupational ? '(PFE+SKT)' : '(PFE Only)'}`}
              </div>
              {bestValue && (
                <div className="title-description best-value">Best Value!</div>
              )}
              {userSubscription.scheduledPlan &&
                plan.id === userSubscription.scheduledPlan && (
                  <div className="title-description">
                    You scheduled this plan to start on{' '}
                    {userSubscription.next_bill_date}!
                  </div>
                )}
              {plan.id === userPlan && (
                <div className="title-description">Your current plan</div>
              )}
            </div>
            <div className="pricing-box">
              <div className="price">${(plan.amount / 100).toFixed(2)}</div>

              <div className="plan-item-description">
                {`${
                  plan.interval === 'month'
                    ? plan.interval_count === 6
                      ? 'per 6 months'
                      : 'per month'
                    : 'per year'
                } (plus tax)`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlanList;
